import MetadataSection from "./MetadataSection";

export default MetadataSection;
